<script setup>
import ModuleManagementPage from '@/components/roles/ModuleManagementPage.vue';
import { useSessionGuard } from '@/composables/useSessionGuard';

// Old "List of Modules" address: same page, opened on the Pages tab.
useSessionGuard();
</script>

<template>
  <ModuleManagementPage default-tab="pages" />
</template>
